<template>
  <div class="home-container">
    <div class="home-content" v-if="buildflags">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="headUrl" label="用户头像" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.headUrl" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="用户手机号码" align="center">
        </el-table-column>
        <el-table-column
          prop="manageUserTypeName"
          label="用户身份"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="userType"
          label="用户类型"
          align="center"
          :formatter="userList"
        >
        </el-table-column> -->
        <el-table-column
          prop="isUserInfo"
          label="查看用户权限"
          align="center"
          :formatter="userInfoTypeList"
        >
        </el-table-column>    
        <el-table-column
          prop="isPatrolTimeoutSms"
          label="接收巡更短信"
          align="center"
          :formatter="isPatrolTimeoutSmsTypeList"
        >
        </el-table-column>      
        <el-table-column label="管理楼栋" align="center">
          <template slot-scope="scope">
            <a href="#" @click="bindBuilding(scope.row)">楼栋列表</a>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >
            <el-button type="text" size="small" @click="changePwd(scope.row)"
              >修改密码</el-button
            >
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户头像" prop="headUrl" label-width="120px">
                <upload
                  :url.sync="addData.headUrl"
                  :src="addData.headUrl"
                  type="img"
                  :width="60"
                  :height="60"
                ></upload>
                <div style="color: red">*(建议尺寸60px * 60px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="用户姓名" prop="userName" label-width="120px"> 
                <el-input
                  v-model="addData.userName"
                  placeholder="请输入用户用户姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="手机号码" prop="phone" label-width="120px">
                <el-input
                  v-model="addData.phone"
                  placeholder="请输入用户手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="用户密码"
                prop="password"
                label-width="120px"
                v-if="modalTitle == '新增'"
              >
                <el-input
                  v-model="addData.password"
                  placeholder="请输入用户密码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"> 
              <el-form-item label="用户身份" prop="manageUserTypeId" label-width="120px">
                <el-select
                  v-model="addData.manageUserTypeId"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="查看用户权限" prop="isUserInfo" label-width="120px">
                <el-select
                  v-model="addData.isUserInfo"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in userInfoList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>     
            <el-col :span="12">
              <el-form-item label="接收巡更短信" prop="isPatrolTimeoutSms" label-width="120px">
                <el-select
                  v-model="addData.isPatrolTimeoutSms"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in userInfoList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>         
            <!-- <el-col :span="12">
              <el-form-item label="用户类型" prop="userType" label-width="120px">
                <el-select
                  v-model="addData.userType"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in userTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
        <el-form
          :model="form"
          ref="forms"
          :rules="rulesPass"
          label-position="center"
        >
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input
              type="password"
              clearable
              show-password
              v-model="form.oldPassword"
              autocomplete="off"
            >
              <i slot="prefix" class="iconfont icon-mima1"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              type="password"
              show-password
              clearable
              v-model="form.newPassword"
              autocomplete="off"
            >
              <i slot="prefix" class="iconfont icon-mima1"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="pswSummit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="home-content" v-else>
      <buildingList :build="build" @buildBack="buildBack"></buildingList>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import buildingList from "./buildingList.vue";
export default {
  components: {
    upload,
    buildingList,
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      userInfoList:[{
        id:1,
        name:'是'
      },{
        id:-1,
        name:'否'
      }],
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      siteList: [],
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        headUrl: "",
        userName: "",
        phone: "",
        password: "",
        userType: "",
        isUserInfo: "",
        manageUserTypeId: "",
      },
      userTypeList: [
        {
          id: 1,
          name: "报事",
        },
        {
          id: 2,
          name: "报修",
        },
      ],
      addDataRules: {
        headUrl: [
          { required: true, message: "请上传用户头像", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入用户手机号码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入用户密码", trigger: "blur" }],
        manageUserTypeId: [
          { required: true, message: "请选择身份", trigger: "blur" },
        ],
        userType: [
          { required: true, message: "请输入用户类型", trigger: "blur" },
        ],
      },
      form: {},
      rulesPass: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      dialogFormVisible: false,
      build: {},
      buildflags: true,
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    userInfoTypeList(row){
      if (row.isUserInfo == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    isPatrolTimeoutSmsTypeList(row){
      if (row.isPatrolTimeoutSms == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    userList(row) {
      if (row.userType == 1) {
        return "报事";
      } else {
        return "报修";
      }
    },
    // 修改密码弹窗
    pswSummit() {
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          var data = {
            id: this.form.id || "",
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword,
          };
          this.$Apis.updatePassword(data).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功!");
              this.form = {};
              this.dialogFormVisible = false;
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 修改密码
    changePwd(row) {
      this.form.id = row.id;
      this.dialogFormVisible = true;
    },
    buildBack() {
      this.buildflags = true;
    },
    // 跳转楼栋列表
    bindBuilding(row) {
      this.buildflags = false;
      this.build = row;
    },
    siteType(row) {
      if (row.userType == 1) {
        return "物业管家";
      } else if (row.userType == 2) {
        return "维修师傅";
      } else if (row.userType == 2) {
        return "维修师傅";
      } else if (row.userType == 2) {
        return "维修师傅";
      }
    },
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.bannerStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
      this.modalTitle = "修改";
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.manageUserDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            headUrl: this.addData.headUrl,
            userName: this.addData.userName,
            phone: this.addData.phone,
            password: this.addData.password || 1,
            userType: 2,
            manageUserTypeId: this.addData.manageUserTypeId,
            isUserInfo: this.addData.isUserInfo,
            isPatrolTimeoutSms:this.addData.isPatrolTimeoutSms
          };
          this.$Apis.manageUserAddUp(data).then((res) => {
            this.btnLoading = false;
            if (res.code == 200) {
              this.isAddModal = false;
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        phone: this.searchForm.phone,
      };
      this.$Apis.manageTypeAllList().then((res) => {
        if (res.code == 200) {
          this.siteList = res.data;
        }
      });
      this.$Apis.manageUserList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>